import React from 'react';
import ReactDOM from 'react-dom/client';
import './main.css';
import App from './App';
import "./firebase.js";
import { AuthProvider } from './contexts/auth-context.js';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);